let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ac6VE")).then(() => parcelRequire('gl3pT'));